import { until } from "@vueuse/core";
import { type Ref } from "vue";

export const whenRefAvailable = async <T>(component: Ref<T>): Promise<Ref<NonNullable<T>>> => {
  await until(component).toBeTruthy();
  return component as Ref<NonNullable<T>>;
};
